import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewWards = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15.2 21.429 12 24l-3.2-2.571 2.556-12.922.644.866.644-.866L15.2 21.429ZM6.814 5.104 9.6 7.85l-1.83 5.815-4.218-1.696 2.627-3.473S.455 8.851 0 5.104h6.814Zm17.186 0c-.456 3.747-6.179 3.392-6.179 3.392l2.627 3.473-4.218 1.696L14.4 7.85l2.786-2.746H24Zm-8-3.327-4 4.908-4-4.908L9.004 0h5.992L16 1.777Z"
    />
  </svg>
);
